<template>
  <div>
    <div>
      <q-table
        flat
        :rows="rows"
        :loading="disable"
        :columns="columns"
        v-model:pagination="pagination"
        class="my-sticky-dynamic"
        row-key="name"
        hide-pagination
        dense
        ref="table"
        :rows-per-page-options="[0]"
        @request="handleRequest"
      >
        <template v-slot:top-right>
          <q-input
            rounded
            outlined
            dense
            debounce="300"
            v-model="filtrar"
            type="text"
            placeholder="Pesquisar"
          >
            <template v-slot:append>
              <q-icon name="search" />
            </template>
          </q-input>
        </template>
        <template v-slot:header="props">
          <q-tr :props="props">
            <q-th
              class="text-weight-bolder"
              v-for="col in props.cols"
              :key="col.name"
              :props="props"
            >
              {{ col.label }}
            </q-th>
          </q-tr>
        </template>

        <template #body-cell-epi="props">
          <q-td>
            <q-btn
              v-if="props"
              round
              color="positive"
              icon="headset"
              flat
              @click="getEpi(props.row)"
            />
          </q-td>
        </template>

        <template #body-cell-hierarquia="props">
          <q-td class="coluna-btn">
            <q-btn
              v-if="props"
              round
              color="positive"
              icon="list"
              flat
              @click="getHierarquia(props.row.id)"
            />
          </q-td>
        </template>
        <template #body-cell-editar="props">
          <q-td class="coluna-btn">
            <q-btn
              v-if="props"
              round
              color="primary"
              flat
              icon="edit"
              @click="getEditar(props.row.id)"
            />
          </q-td>
        </template>
        <template #body-cell-desligar="props">
          <q-td class="coluna-btn">
            <q-btn
              round
              color="red"
              icon="close"
              flat
              @click="
                (linha = props.row), (desligamentoDialog = !desligamentoDialog)
              "
            />
          </q-td>
        </template>
        <template #body-cell-name="props">
          <q-td>
            <span>{{ props.row.name }}</span>
          </q-td>
        </template>
        <template #body-cell-cargo="props">
          <q-td>
            <span>{{ props.row.cargo }}</span>
          </q-td>
        </template>
        <template #body-cell-email="props">
          <q-td>
            <span>{{ props.row.email }}</span>
          </q-td>
        </template>
        <template #body-cell-sap="props">
          <q-td>
            <span>{{ props.row.sap }}</span>
          </q-td>
        </template>
        <template #body-cell-tnumber="props">
          <q-td>
            <span>{{ props.row.tnumber }}</span>
          </q-td>
        </template>
        <template #body-cell-function="props">
          <q-td>
            <span>{{ props.row.function_model?.name }}</span>
          </q-td>
        </template>
        <template #body-cell-imagens="props">
          <q-td>
            <q-btn
              round
              color="brand-1"
              flat
              icon="preview"
              @click="getBiometriaList(props.row.id)"
            />
          </q-td>
        </template>
        <template #body-cell-afastar="props">
          <q-td class="coluna-btn">
            <q-btn
              round
              color="red"
              flat
              icon="person_remove"
              @click="
                (linha = props.row), (afastamentoDialog = !afastamentoDialog)
              "
            />
          </q-td>
        </template>
        <template #body-cell-facial="props">
          <q-td class="coluna-btn">
            <div
              v-if="
                $store.state.autenticacao.usuarioLogado.permissoes.gmapi.roles.indexOf(
                  'vouchers-auth-facial'
                ) != -1
              "
              class="relative-position"
              style="display: inline-block"
            >
              <q-btn
                round
                :color="
                  props.row.biometria_facial == 1 ? 'positive' : 'negative'
                "
                flat
                icon="face"
                size="15px"
                @click="(userId = props.row.id), (facial = !facial)"
              />

              <q-icon
                :name="
                  props.row.biometria_facial == 1 ? 'check_circle' : 'cancel'
                "
                :style="{
                  color:
                    props.row.biometria_facial == 1 ? '#2E7D32' : '#C62828',
                }"
                size="18px"
                class="absolute-bottom-right"
                style="bottom: 1px; right: 2px; z-index: 0"
              >
                <q-tooltip
                  anchor="top middle"
                  self="bottom middle"
                  :class="
                    props.row.biometria_facial == 1
                      ? 'bg-gray text-white'
                      : 'bg-gray text-white'
                  "
                >
                  {{
                    props.row.biometria_facial == 1
                      ? "Biometria facial coletada"
                      : "Biometria facial não coletada"
                  }}
                </q-tooltip>
              </q-icon>
            </div>
          </q-td>
        </template>

        <template #body-cell-biometry="props">
          <q-td class="coluna-btn">
            <div
              style="cursor: pointer"
              @click="
                (userId = props.row.id),
                  (cadastrarBiometria = !cadastrarBiometria)
              "
            >
              <q-img
                width="49px"
                heigth="50px"
                v-if="!props.row.biometry"
                src="../../../../assets/bioNO.png"
                fit="fill"
              />
              <q-img
                width="49px"
                heigth="50px"
                v-else
                src="../../../../assets/bioOK.png"
                fit="fill"
              />
              <q-tooltip
                anchor="top middle"
                self="bottom middle"
                :class="
                  props.row.biometry
                    ? 'bg-gray text-white'
                    : 'bg-gray text-white'
                "
              >
                {{
                  props.row.biometry
                    ? "Biometria coletada"
                    : "Biometria não coletada"
                }}
              </q-tooltip>
            </div>
          </q-td>
        </template>
        <template #body-cell-termo="props">
          <q-td class="coluna-btn">
            <div class="relative-position" style="display: inline-block">
              <q-icon
                v-if="props.row.data_aceite_biometria"
                size="lg"
                name="book"
                color="positive"
                style="cursor: pointer"
                @click="
                  aceitarTermo(
                    props.row.id,
                    props.row.data_aceite_biometria,
                    props.row.sap
                  )
                "
              />
              <q-icon
                style="cursor: pointer"
                v-else
                size="lg"
                name="book"
                color="negative"
                @click="
                  aceitarTermo(
                    props.row.id,
                    props.row.data_aceite_biometria,
                    props.row.sap,
                    props.row.name
                  )
                "
              />

              <q-icon
                :name="
                  props.row.data_aceite_biometria ? 'check_circle' : 'cancel'
                "
                :style="{
                  color: props.row.data_aceite_biometria
                    ? '#2E7D32'
                    : '#C62828',
                }"
                size="18px"
                class="absolute-bottom-right"
                style="bottom: -4px; right: -8px; z-index: 0"
              >
                <q-tooltip
                  anchor="top middle"
                  self="bottom middle"
                  :class="
                    props.row.data_aceite_biometria
                      ? 'bg-gray text-white'
                      : 'bg-gray text-white'
                  "
                >
                  {{
                    props.row.data_aceite_biometria
                      ? "Termo aceito"
                      : "Termo não aceito"
                  }}
                </q-tooltip>
              </q-icon>
            </div>
          </q-td>
        </template>
      </q-table>

      <div class="row justify-start q-mt-md">
        <q-pagination
          :disable="disable"
          v-model="pagination.page"
          color="brand-5"
          active-color="secondary"
          active-text-color="white"
          :max="pagesNumber"
          :max-pages="5"
          :boundary-numbers="false"
          :direction-links="true"
          size="sm"
        />
      </div>
    </div>
    <BiometriaCadastro
      :modal="cadastrarBiometria"
      :userId="userId"
      :titulo="'Cadastro de Biometria'"
      :tipoBiometria="'cadastro'"
      @atualizarBiometrias="atualizarTemplatesBiometria"
    />

    <cadastro-facial
      :userId="userId"
      @close="fecharFacial"
      v-model="facial"
    ></cadastro-facial>
    <dialog-info-design
      mensagem="Confirma desligamento?"
      subMensagem="Tem certeza que deseja desligar o colaborador?"
      :exibir="desligamentoDialog"
      :showCancelar="true"
      @resultado="desligarUsuario"
    />
    <dialog-info-design
      mensagem="Confirma afastamento?"
      subMensagem="Tem certez que deseja afastar o colaborador?"
      :exibir="afastamentoDialog"
      :showCancelar="true"
      @resultado="afastarUsuario"
    />
  </div>
</template>

<script>
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import { useRouter, useRoute } from "vue-router";
import { ref, onMounted, computed, watch } from "vue";

import BiometriaCadastro from "../../../biometria/views/Biometria.vue";
import CadastroFacial from "../components/CadastroFacial.vue";
import DialogInfoDesign from "../../../../components/DialogInfoDesign.vue";
export default {
  props: ["filtros", "unidades", "atualizar"],
  components: { BiometriaCadastro, CadastroFacial, DialogInfoDesign },
  setup(props) {
    const store = useStore();
    const rows = ref([]);
    const router = useRouter();
    const desligamentoDialog = ref(false);
    const afastamentoDialog = ref(false);
    const route = useRoute();
    const quasar = useQuasar();
    const disable = ref(true);
    const unidade = ref("");
    const table = ref("");
    const filtrar = ref("");
    let cadastrarBiometria = ref(false);
    const linha = ref(null);
    const userId = ref("");
    const facial = ref(false);
    const tenentsPorRole = ref(["starrett", "dexco"]);
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 10,
      rowsNumber: 15,
    });
    const getDados = async (page = 1, rowsPerPage = 25) => {
      disable.value = true;
      quasar.loading.show();
      try {
        let response = await store.dispatch("user/getUsuarios", {
          vendor_id: unidade.value.id,
          page,
          per_page: rowsPerPage,
          search: filtrar.value,
          biometria: props.filtros.biometria.value,
          ghe: props.filtros.ghe,
          cost_center_id: props.filtros.cost_center,
          cargo: props.filtros.cargo,
        });

        const roles =
          store.state.autenticacao.usuarioLogado.permissoes.gmapi.roles;

        columns.value = columns.value.filter((column) => {
          const canSeeFacial = roles.includes("vouchers-auth-facial");
          const canSeeImagens = roles.includes("biometria-facial-find");

          if (!canSeeFacial && column.name === "facial") {
            return false;
          }

          if (!canSeeImagens && column.name === "imagens") {
            return false;
          }

          return true;
        });

        rows.value = response.data.results.data;

        pagination.value.page = response.data.results.current_page;
        pagination.value.rowsPerPage = response.data.results.per_page;
        pagination.value.rowsNumber = response.data.results.total;
        disable.value = false;
        quasar.loading.hide();
      } catch (error) {
        quasar.loading.hide();
        quasar.notify({
          message: "Erro a o procurar dados",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    onMounted(getDados);

    const desligarUsuario = async (resultado) => {
      desligamentoDialog.value = false;
      if (resultado) {
        if (
          tenentsPorRole.value.includes(store.state.autenticacao.cliente[0])
        ) {
          if (
            store.state.autenticacao.usuarioLogado.roleLevel >=
            linha.value?.roles[0]?.id
          ) {
            quasar.notify({
              message:
                "Você não pode editar um usuário com perfil maior que o seu",
              color: "negative",
              actions: [
                {
                  label: "Fechar",
                  color: "white",
                  handler: () => {
                    /* ... */
                  },
                },
              ],
            });
            return;
          }
        }

        if (linha.value.email.includes("@multpex.com.br")) {
          quasar.notify({
            message: "Esse usuario não pode ser desligado",
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          return;
        }
        try {
          await store.dispatch("user/desligarUsuario", {
            id: linha.value.id,
          });
          quasar.notify({
            message: "Usuario desligado com sucesso",
            color: "positive",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          getDados(pagination.value.page, pagination.value.rowsPerPage);
        } catch (error) {
          quasar.notify({
            message: "Erro a o desligar usuario",
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
        getDados(pagination.value.page, pagination.value.rowsPerPage);
      }
    };

    const afastarUsuario = async (resultado) => {
      afastamentoDialog.value = false;
      if (resultado) {
        if (
          tenentsPorRole.value.includes(store.state.autenticacao.cliente[0])
        ) {
          if (
            store.state.autenticacao.usuarioLogado.roleLevel >=
            linha.value?.roles[0]?.id
          ) {
            quasar.notify({
              message:
                "Você não pode editar um usuário com perfil maior que o seu",
              color: "negative",
              actions: [
                {
                  label: "Fechar",
                  color: "white",
                  handler: () => {
                    /* ... */
                  },
                },
              ],
            });
            return;
          }
        }

        if (linha.value.email.includes("@multpex.com.br")) {
          quasar.notify({
            message: "Esse usuario não pode ser afastado",
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          return;
        }
        try {
          await store.dispatch("user/afastarUsuario", {
            id: linha.value.id,
          });
          quasar.notify({
            message: "Usuario afastado com sucesso",
            color: "positive",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          getDados(pagination.value.page, pagination.value.rowsPerPage);
        } catch (error) {
          quasar.notify({
            message: "Erro a o afastar usuario",
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
        getDados(pagination.value.page, pagination.value.rowsPerPage);
      }
    };

    const handleRequest = async () => {
      getDados(pagination.value.page, pagination.value.rowsPerPage);
    };

    const getHierarquia = async (id) => {
      router.push({ name: "usuario-hierarquia", params: { id: id } });
    };

    const getBiometriaList = async (id) => {
      router.push({ name: "usuario-biometria-list", params: { id: id } });
    };

    const getEpi = async (row) => {
      let dados = { id: row.id, nome: row.name };
      router.push({
        name: "usuario-epi",
        params: { id: JSON.stringify(dados) },
      });
    };

    const getEditar = async (id) => {
      router.push({ name: "usuario-editar", params: { id: id } });
    };

    const atualizarTemplatesBiometria = async () => {
      try {
        await store.dispatch("user/atualizarTemplatesBiometria");
        getDados(pagination.value.page, pagination.value.rowsPerPage);
        quasar.notify({
          message: "Atualizando templates de biometria..",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        quasar.notify({
          message: "Erro ao atualizar templates de biometria",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const aceitarTermo = async (id, termo, matricula, nome) => {
      if (
        store.state.autenticacao.cliente[0] == "staging-vale" ||
        store.state.autenticacao.cliente[0] == "vale-epiexpress"
      ) {
        router.push({
          name: "usuario-termo",
          params: {
            id: JSON.stringify({
              id: id,
              termo: termo,
              matricula: matricula,
              nome: nome,
            }),
          },
        });
      }
    };

    const fecharFacial = async (value) => {
      facial.value = value;
    };

    const getUnidade = () => {
      if (
        localStorage.unidade &&
        localStorage.unidade != null &&
        localStorage.unidade != "null"
      ) {
        let getunidade = localStorage.getItem("unidade");
        unidade.value = JSON.parse(getunidade);
      }
      getDados(pagination.value.page, pagination.value.rowsPerPage);
    };

    onMounted(getUnidade);

    watch(
      () => pagination.value.page,
      () => {
        disable.value = true;
        router.push({
          path: route.path,
          query: { page: pagination.value.page },
        });
        handleRequest();
      }
    );

    watch(
      () => props.atualizar,
      () => {
        handleRequest();
      }
    );

    watch(
      () => filtrar.value,
      () => {
        handleRequest();
      }
    );

    watch(
      () => store.state.org.unidadeData,
      () => {
        unidade.value.id = store.state.org.unidadeData.id;
        getDados(pagination.value.page, pagination.value.rowsPerPage);
      }
    );

    const columns = ref([
      {
        name: "id",
        label: "ID",
        field: "id",
        align: "left",
      },
      {
        name: "name",
        label: "Nome",
        field: "name",
        align: "left",
      },
      {
        name: "email",
        label: "Email",
        field: "email",
        align: "left",
      },
      {
        name: "cargo",
        label: "Cargo",
        field: "cargo",
        align: "left",
      },
      {
        name: "function",
        label: "Processo / Função",
        field: "function",
        align: "left",
      },
      {
        name: "sap",
        label: "ID Usuário",
        field: "sap",
        align: "left",
      },
      {
        name: "tnumber",
        label: "Matricula",
        field: "tnumber",
        align: "left",
      },
      {
        name: "epi",
        label: "EPI's",
        field: "epi",
        align: "center",
      },

      {
        name: "hierarquia",
        label: "Hierarquia",
        field: "hierarquia",
        align: "center",
      },
      {
        name: "editar",
        label: "Editar",
        field: "editar",
        align: "center",
      },
      {
        name: "desligar",
        label: "Desligar",
        field: "desligar",
        align: "center",
      },
      {
        name: "imagens",
        label: "Visualizar Faciais",
        field: "imagens",
        align: "left",
      },
      {
        name: "afastar",
        label: "Afastar",
        field: "afastar",
        align: "center",
      },
      {
        name: "facial",
        label: "Facial",
        field: "facial",
        align: "center",
      },
      {
        name: "biometry",
        label: "Biometria",
        field: "biometry",
        align: "center",
      },
      {
        name: "termo",
        label: "Termo Aceite",
        field: "termo",
        align: "center",
      },
    ]);

    return {
      rows,
      columns,
      getDados,
      unidade,
      pagination,
      handleRequest,
      desligarUsuario,
      disable,
      table,
      getEpi,
      filtrar,
      afastarUsuario,
      getHierarquia,
      facial,
      getEditar,
      fecharFacial,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      cadastrarBiometria,
      userId,
      atualizarTemplatesBiometria,
      aceitarTermo,
      desligamentoDialog,
      afastamentoDialog,
      linha,
      getBiometriaList,
    };
  },
};
</script>

<style scoped>
.q-table__top,
thead tr:first-child th {
  background-color: #eef3fe;
}
/* bg color is important for th; just specify one */

thead tr th {
  position: sticky;
  z-index: 1;
}
thead tr:first-child th {
  top: 0;
}

/* this is when the loading indicator appears */
.q-table--loading thead tr:last-child th {
  top: 0;
}
.my-sticky-dynamic {
  max-height: 600px;
}
thead tr th {
  white-space: pre-wrap !important;
}
tbody tr td {
  white-space: pre-wrap;
}
</style>
